export default __webpack_public_path__ + "static/media/cancel.486caaf0.svg";